import React, { useEffect, useState } from 'react';
import { useQueryParam } from 'gatsby-query-params';
import { API } from 'aws-amplify';
import Layout from '../components/layout';
import PageTopper, { LinkD } from '../components/pagetopper';
import { useChanList, ChannelChoice } from '../components/chanutil';

import { useSnackbar } from 'notistack';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Paper from '@material-ui/core/Paper';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import ChevronRight from '@material-ui/icons/ChevronRight';
import RefreshIcon from '@material-ui/icons/Refresh';

import { chanChgQuery } from '../graphql/queries.js';

var prettyTime = new Intl.DateTimeFormat("en-US", {
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
});

const showDebug = (rawjson) => {
    return (<pre>Response:<br />{JSON.stringify(rawjson, null, 2)}</pre>);
};

const ChanListChgPage = () => {
    const { enqueueSnackbar } = useSnackbar();
    const vdebug = useQueryParam('debug', '');

    const [hdata, setHdata] = useState({"data":{"listOfferChg":{"mwsoffer":{"items": [], "loading": "true"}}}});
    const [currchan, setCurrChann] = useState('');

    const [wlimit, setWlimit] = useState(25);
    const [ncursor, setNcursor] = useState('');
    const [pgnum, setPgnum] = useState(1);
    const [pgserial, setPgserial] = useState(0);

    const chlist = useChanList(1, 1, vdebug);
    useEffect(() => {
        if ((chlist.length > 0) && (currchan === '')) {
            setCurrChann(chlist[0].chname);
        }
    }, [chlist, currchan] ) ;

    // get list
    useEffect(() => {
      let wkpend = true;
      const fetchData = async (chgData) => {
          try {
              if (vdebug !== null) {
                  console.log(pgserial);
              }
              const result = await API.graphql({query: chanChgQuery, variables: chgData});
              if (vdebug !== null) {
                  console.log("gql success");
                  console.log(result);
              }
              if (wkpend) {
                  if (result.data.listOfferChg.mwsoffer.items) {
                      enqueueSnackbar(`showing ${result.data.listOfferChg.mwsoffer.items.length} entries`,
                        {variant: 'info', anchorOrigin: {vertical: 'bottom', horizontal: 'right'}} );
                  }
                  setHdata(result);
                  wkpend = false;
              }
          } catch (result) {
              if (vdebug !== null) {
                  console.log("gql error", result);
              }
              enqueueSnackbar(`error retrieving history`, {variant: 'error'});
          }
      };

      if (currchan) {
          const chgData = {
              "currchan": `${currchan}`,
              "rlimit": `${wlimit}`,
              "nextToken": `${ncursor}`,
          };
          fetchData(chgData);
      }
      return() => (wkpend = false)
    }, [wlimit, ncursor, currchan, pgserial, vdebug, enqueueSnackbar] ) ;


return (
  <Layout>
  <PageTopper pname="Channel Changes" vdebug={vdebug}
    helpPage="/help/chanlist"
    />

  <Paper elevation={5} style={{clear: 'both'}}>
      <span style={{marginLeft: '2px', float: 'left', display: 'flex'}}>
      <ChannelChoice currchan={currchan} setchan={setCurrChann} channels={chlist}/>
      </span>

      <span style={{float: 'right', display: 'flex'}}>
      <IconButton aria-label="refresh" onClick={() => {setPgserial(pgserial+1)} }>
      <RefreshIcon fontSize="inherit" /></IconButton>

      <Select aria-label="Items per Page" name="plimit" id="plimit"
        value={wlimit}
        style={{fontSize: 'small'}}
        onChange={e => {setWlimit(e.target.value); setNcursor(''); setPgnum(1)} }>
        <MenuItem value="10" >&nbsp;&nbsp;10/page</MenuItem>
        <MenuItem value="25">&nbsp;25/page</MenuItem>
        <MenuItem value="50"> 50/page</MenuItem>
        <MenuItem value="100"> 100/page</MenuItem>
      </Select>

    <span style={{float: 'right', fontSize: 'small'}}>
      <IconButton aria-label="first page" onClick={() => {setNcursor(''); setPgnum(1)} } disabled = {pgnum === 1}><FirstPageIcon fontSize="inherit" /></IconButton>
      Page {pgnum}
      <IconButton aria-label="next page" onClick={() => {setNcursor(hdata.data.listOfferChg.mwsoffer.nextToken); setPgnum(() => pgnum + 1)} } disabled = {!hdata.data.listOfferChg.mwsoffer.nextToken}><ChevronRight fontSize="inherit" /></IconButton>
    </span>

      </span>

      <TableContainer style={{ maxHeight: 440 }}><Table size="small" stickyHeader>
         <TableHead><ChgSummHeader /></TableHead>
        <TableBody>
        { hdata.data && hdata.data.listOfferChg && hdata.data.listOfferChg.mwsoffer.items &&
          hdata.data.listOfferChg.mwsoffer.items.map(item => (
          ChgSummListItem(item, vdebug)
         )) }

      </TableBody></Table></TableContainer>
      { (hdata.data.listOfferChg.mwsoffer.loading === "true") &&
        <center>Loading...</center>
      }

    </Paper>

    {vdebug && showDebug(hdata)}
  </Layout>
)}

const StyledTableCell = withStyles((theme) => ({
  head: {
      padding: '2px',
      '&:first-of-type': {
          padding: '5px',
      },
    backgroundColor: '#444464',
    color: theme.palette.common.white,
  },
  body: {
    padding: '2px',
    '&:first-of-type': {
        padding: '5px',
    },
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ChgSummHeader = () => {
    return(
        <TableRow>
        <StyledTableCell>changed</StyledTableCell>
        <StyledTableCell>asin</StyledTableCell>
        <StyledTableCell>name</StyledTableCell>
        <StyledTableCell># m/o<br /> =/&lt;</StyledTableCell>
        <StyledTableCell>fba<br />fbm</StyledTableCell>
        <StyledTableCell>buybox</StyledTableCell>
            <StyledTableCell>map</StyledTableCell>
        <StyledTableCell>reason</StyledTableCell>
        <StyledTableCell>rank</StyledTableCell>
        </TableRow>
        )
}

export const ChgSummListItem = (item, vdebug) => {
    return(
        <StyledTableRow key={item.asin}>
           <StyledTableCell>{ prettyTime.format(new Date(item.pub)) }</StyledTableCell>
           <StyledTableCell><LinkD vdebug={vdebug} to={`/chanasinchg?chan=amz-us&asin=${item.asin}`}>{ item.asin }</LinkD></StyledTableCell>
               <StyledTableCell>{ item.unote }</StyledTableCell>
               <StyledTableCell>{ item.qcnt }/{ item.ocnt }<br />{ item.mcnt }/{ item.ucnt }</StyledTableCell>
               <StyledTableCell>{ item.fbaamt }<br />{ item.fbmamt }</StyledTableCell>
               <StyledTableCell>{ item.bbamt }<br />{ item.bbsid }</StyledTableCell>
               <StyledTableCell>{ item.map }</StyledTableCell>
           <StyledTableCell>{ item.reason }</StyledTableCell>
           <StyledTableCell>{ item.rank }</StyledTableCell>

        </StyledTableRow>
        )
}

export default ChanListChgPage

